import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "../assets/styles/loader.css";

const Loader = ({ title, vendorColor, loadDuration, loaderBlockStyle }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    if (typeof loadDuration !== "number" || loadDuration <= 0) {
      console.error("Invalid loadDuration:", loadDuration);
      return;
    }

    const interval = 100; // Update interval in milliseconds
    const totalDuration = loadDuration * 1000; // Convert loadDuration to milliseconds
    const increment = (100 / totalDuration) * interval; // Calculate increment

    setProgress(0); // Reset progress when loader becomes visible

    // console.log("Total Duration:", totalDuration, "ms");
    // console.log("Increment per interval:", increment);

    const intervalId = setInterval(() => {
      setProgress((prevProgress) => {
        const newProgress = prevProgress + increment;
        if (newProgress >= 100) {
          clearInterval(intervalId);
          return 100;
        }
        return newProgress;
      });
    }, interval);

    return () => clearInterval(intervalId);
  }, [loadDuration]);

  return (
    <>
      <div className="bg-black/[0.4] flex justify-center flex-col gap-3 items-center absolute left-0 top-0 w-full h-full z-[1300]">
        <h2 className="text-xl text-white font-semibold">{title}</h2>
        <div className="loader--facebook">
            <div style={loaderBlockStyle}></div>
            <div style={loaderBlockStyle}></div>
            <div style={loaderBlockStyle}></div>
        </div>
        <div className="loader-progress-container">
          <div
            className="loader-progress-bar"
            style={{ 
              width: `${progress}%`,
              backgroundColor: vendorColor
            }}
          ></div>
        </div>
        {/* <div className="text-white">{Math.round(progress)}%</div> */}
      </div>
    </>
  );
};

Loader.propTypes = {
  title: PropTypes.string.isRequired,
  vendorColor: PropTypes.string.isRequired,
  loadDuration: PropTypes.number.isRequired,
};

export default Loader;
